import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  IconButton
} from "@mui/material";
import { MdDeleteForever, MdEdit } from "react-icons/md";

const TabsCard = ({ product, onEdit, onDelete, onOpenDetails }) => {
  const name = product?.name || 'Untitled Tab';
  const status = (product?.status || 'inactive').toLowerCase();
  
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "12px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
        background: "linear-gradient(145deg, #ffffff, #f9fafb)",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 12px 30px rgba(0,0,0,0.12)"
        },
        maxWidth: 350,
        margin: "auto"
      }}
    >
      <CardContent sx={{ padding: "20px", flexGrow: 1 }}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ backgroundColor: "#f0f2f5", borderRadius: "8px" }}
            onClick={() => onOpenDetails && onOpenDetails(product)}
          >
            <img
              src="./img/tab.png"
              alt="tabs"
              style={{
                width: 80,
                height: 80,
                objectFit: "contain",
                padding: "8px",
                cursor: "pointer"
              }}
            />
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontFamily: "Mulish, sans-serif",
                fontWeight: 700,
                fontSize: "1.25rem",
                lineHeight: 1.3,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                color: "#1a202c",
                cursor: "pointer"
              }}
              onClick={() => onOpenDetails && onOpenDetails(product)}
            >
              {name}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" gap={1}>
            <Chip
              label={product?.status || 'inactive'}
              size="small"
              color={status === "active" ? "success" : "default"}
              sx={{
                fontWeight: 600,
                borderRadius: "12px",
                backgroundColor: status === "active" ? "#1f6322ff" : "#f18d2eff",
                color: "white"
              }}
            />
            <Box display="flex" justifyContent="flex-end" gap={1}>
              <IconButton
                size="small"
                onClick={() => onEdit && onEdit(product)}
                aria-label={`Edit ${name}`}
                sx={{
                  "&:hover": { backgroundColor: "#bbdefb" }
                }}
              >
                <MdEdit style={{ color: "#1976d2", fontSize: "1.4rem" }} />
              </IconButton>
              <IconButton
                size="small"
                color="error"
                onClick={() => onDelete && onDelete(product)}
                aria-label={`Delete ${name}`}
                sx={{
                  "&:hover": { backgroundColor: "#ffcdd2" }
                }}
              >
                <MdDeleteForever
                  style={{ color: "#d32f2f", fontSize: "1.4rem" }}
                />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TabsCard;
